import { endpoints } from 'Constants';

const questionServices = {
	list: (params) => ({
		baseURL: endpoints.QUESTION.LIST(),
		method: 'GET',
		params: params?.query,
	}),
	reply: (params) => ({
		baseURL: endpoints.QUESTION.REPLY(params?.id),
		method: 'POST',
		data: params?.data,
	}),
};

export default questionServices;
